<div class="w-full h-full">
<app-tool-loader [isLoading]="isLoading()" positionUnset="true">
  <p-toolbar>
    <ng-template #start>
      <div class="flex space-x-2 toolbar-menu">
        <p-select
          [options]="singleMultiple"
          (onChange)="modeToggle($event.value)"
          [(ngModel)]="selectedSingleMultiple"
          appendTo="body"
        ></p-select>

        <p-selectButton
          [options]="resultsDisplay"
          [(ngModel)]="selectedResultsDisplay"
          (onChange)="onSelectResultsDisplay($event)"
          [allowEmpty]="false"
        ></p-selectButton>

        @if (selectedResultsDisplay === 'plot') {
          <p-selectButton
            [options]="depthView"
            [(ngModel)]="selectedDepthView"
            (onChange)="depthViewToggle($event)"
            [allowEmpty]="false"
          ></p-selectButton>
        }
      </div>
    </ng-template>

    <ng-template #center>
      <div class="flex gap-2 items-center jusitfy-end content-end">
        @if (selectedSingleMultiple === 'singleOperation') {
          <p-checkbox
            size="small"
            (onChange)="syncPressAndTemp($event)"
            [(ngModel)]="syncThermalResults"
            pTooltip="Sync P&T results"
            binary="true"
          ></p-checkbox>
        }

        @if (selectedSingleMultiple === 'singleOperation') {
          <p-select
            [(ngModel)]="selectedOperation"
            [options]="operations"
            (onChange)="onOperationSelected($event, true)"
            optionLabel="name"
            appendTo="body"
            class="w-[300px]"
          ></p-select>
        }

        @if (selectedSingleMultiple === 'operationType') {
          <p-select
            [options]="operationTypes"
            [(ngModel)]="selectedOperationType"
            (onChange)="onOperationTypeSelected($event.value)"
            appendTo="body"
          ></p-select>
        }

        @if (selectedSingleMultiple === 'multipleOperation' || selectedSingleMultiple === 'operationType') {
          <app-units-select-input
            class="w-[200px]"
            [(ngModel)]="selectedAnnulus"
            [options]="annulusNames"
            optionLabel="label"
            dataKey="value"
            [optionLabelFormatter]="formatAnnulusOption"
            [unit]="shortLengthUnit"
            (onChange)="annulusDropdownChange($event)"
            [readOnly]="selectedSingleMultiple === 'operationType'"
            ariaLabel="Pressure result location"
            appendTo="body"
          ></app-units-select-input>
        }

        <p-button
          outlined="true"
          size="small"
          [disabled]="moveUpDisabled"
          (onClick)="onUpDownButtonClick('up', true)"
          icon="pi pi-arrow-up"
        ></p-button>

        <p-button
          outlined="true"
          size="small"
          [disabled]="moveDownDisabled"
          (onClick)="onUpDownButtonClick('down', true)"
          icon="pi pi-arrow-down"
        ></p-button>

        @if (phases?.length > 1 && selectedSingleMultiple === 'singleOperation') {
          <p-select
            class="ml-2"
            [options]="phases"
            [ngModel]="selectedPhase"
            (onChange)="onPhaseSelected($event, true)"
            optionLabel="phaseNumber"
            appendTo="body"
          >
            <ng-template pTemplate="selectedItem">
              Phase {{ selectedPhase?.phaseNumber }}
            </ng-template>
            <ng-template let-phase pTemplate="item">
              Phase {{ phase.phaseNumber }}
            </ng-template>
          </p-select>
        }
      </div>
    </ng-template>

    <ng-template #end></ng-template>
  </p-toolbar>

  <div class="flex-1 min-h-0 overflow-hidden" [hidden]="selectedResultsDisplay !== 'grid'">
    <app-perical-results-grid
      tableName="Thermal Results - Pressures"
      [tableData]="resultsGrid"
      [columnDefinitions]="
        selectedSingleMultiple === 'singleOperation'
          ? cols
          : operationNames
      "
      [selectedOperation]="selectedOperation"
      [virtualScroll]="true"
    />
  </div>

  @if (selectedResultsDisplay === 'plot') {
    <app-thermal-results-plot
      class="flex-1 min-h-0"
      xAxisTitle="Pressure ({{ pressUnit }})"
      depthUnit="{{ depthUnit }}"
      plotTitle="Thermal Results - Pressures"
      [plotData]="
        selectedSingleMultiple === 'singleOperation'
          ? results
          : multipleResultsFull
      "
      [columnDefinitions]="
        selectedSingleMultiple === 'singleOperation'
          ? cols
          : operationNames
      "
      [selectedDepthDisplay]="selectedDepthView"
      [plotName]="plotName"
      [downloadPlotName]="
        selectedSingleMultiple === 'singleOperation'
          ? 'single_operation_plot'
          : 'multiple_operation_plot'
      "
      [thermalResultsStore]="pressureResultsStore"
    ></app-thermal-results-plot>
  }

</app-tool-loader>
</div>

<p-dialog [draggable]="false" [(visible)]="missingOperations" [closable]="false" appendTo="self">
  <i class="pi pi-exclamation-circle pr-1"></i>
  <label> No Operations Exist: Please specify at least one operation to view results.</label>
  <br />
  <br />
</p-dialog>

<p-dialog [draggable]="false" [(visible)]="needToCalculate" [closable]="false" appendTo="self">
  <i class="pi pi-exclamation-circle pr-1"></i>
  <label>{{ calculationError }}</label>
  <br />
  <br />
</p-dialog>
